var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', _vm._l(_vm.events, function (event, i) {
    return _c('div', {
      key: i,
      staticClass: "event-listing",
      class: {
        'active-event': i === _vm.activeId
      }
    }, [_c('EventSummary', {
      attrs: {
        "event": event,
        "join": true,
        "details": false
      }
    }), _c('transition', {
      attrs: {
        "name": "slide"
      }
    }, [i === _vm.activeId ? _c('div', {
      staticClass: "row"
    }, [_c('section', {
      staticClass: "col-md-12"
    }, [_c('div', {
      staticClass: "event-description"
    }, [_c('h4', [_vm._v("DESCRIPTION")]), _c('div', {
      domProps: {
        "innerHTML": _vm._s(event.details)
      }
    })])])]) : _vm._e()])], 1);
  }), 0);
}
var staticRenderFns = []

export { render, staticRenderFns }